export const operators = ["and_all", "or_all"];
